import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

  displayFaq: boolean = environment.passenger.application.faq.footerEnabled;
  displayCgu: boolean = environment.passenger.application.footer.cgu.enabled;
  displayLegalNotice: boolean = environment.passenger.application.footer.legalNotice.enabled;

  faqUrlPath: string = environment.passenger.application.faq.externalUrl || 'faq';
  cguUrlPath: string = environment.passenger.application.footer.cgu.externalUrl || 'cgu';
  legalNoticeUrlPath: string = environment.passenger.application.footer.legalNotice.externalUrl || 'legal-notice';

  isFaqExternal: boolean = !!environment.passenger.application.faq.externalUrl;
  isCguExternal: boolean = !!environment.passenger.application.footer.cgu.externalUrl;
  isLegalNoticeExternal: boolean = !!environment.passenger.application.footer.legalNotice.externalUrl;

}
